import { NgModule } from '@angular/core';

import { LoadFontsComponent } from './load-fonts.component';

@NgModule({
  imports: [LoadFontsComponent],
  exports: [LoadFontsComponent],
  providers: [],
})
export class CoreLoadFontsModule {}
